module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"date":"Datum","loadAll":"Alle laden","manufacturer":"Hersteller","period":"Zeitraum","receipts":"Belege","representative":"Außendienstmitarbeiter:in","site":"Markt","state":"Status"},"en":{"date":"Date","loadAll":"Load all","manufacturer":"Manufacturer","period":"Period","receipts":"Receipts","representative":"Representative","site":"Site","state":"State"}}')
  delete Component.options._Ctor
}
